var map = {
	"./AAPLUSD.svg": 368,
	"./AAVEUSD.svg": 369,
	"./ABNBUSD.svg": 370,
	"./ADAUSD.svg": 371,
	"./ALGOUSD.svg": 372,
	"./AMDUSD.svg": 373,
	"./AMZNUSD.svg": 374,
	"./APEUSD.svg": 375,
	"./ATOMUSD.svg": 376,
	"./AUDUSD.svg": 377,
	"./AVAXUSD.svg": 378,
	"./BATUSD.svg": 379,
	"./BAUSD.svg": 380,
	"./BCHUSD.svg": 381,
	"./BNBUSD.svg": 382,
	"./BTCUSD.svg": 383,
	"./CHZUSD.svg": 384,
	"./COMPUSD.svg": 385,
	"./CRVUSD.svg": 386,
	"./DASHUSD.svg": 387,
	"./DIAUSD.svg": 388,
	"./DISUSD.svg": 389,
	"./DOGEUSD.svg": 390,
	"./DOTUSD.svg": 391,
	"./ENJUSD.svg": 392,
	"./EOSUSD.svg": 393,
	"./ETCUSD.svg": 394,
	"./ETHUSD.svg": 395,
	"./EURCHF.svg": 396,
	"./EURGBP.svg": 397,
	"./EURJPY.svg": 398,
	"./EURNOK.svg": 399,
	"./EURSEK.svg": 400,
	"./EURUSD.svg": 401,
	"./FTMUSD.svg": 402,
	"./GBPUSD.svg": 403,
	"./GMEUSD.svg": 404,
	"./GOOGLUSD.svg": 405,
	"./GRTUSD.svg": 406,
	"./ICPUSD.svg": 407,
	"./INTCUSD.svg": 408,
	"./IWMUSD.svg": 409,
	"./KOUSD.svg": 410,
	"./KRW.svg": 411,
	"./LINKUSD.svg": 412,
	"./LTCUSD.svg": 413,
	"./MANAUSD.svg": 414,
	"./MATICUSD.svg": 415,
	"./MAUSD.svg": 416,
	"./MCDUSD.svg": 417,
	"./METAUSD.svg": 418,
	"./MKRUSD.svg": 419,
	"./MSFTUSD.svg": 420,
	"./NEARUSD.svg": 421,
	"./NKEUSD.svg": 422,
	"./NOK.svg": 423,
	"./NVDAUSD.svg": 424,
	"./NZDUSD.svg": 425,
	"./OMGUSD.svg": 426,
	"./PFEUSD.svg": 427,
	"./PYPLUSD.svg": 428,
	"./QNTUSD.svg": 429,
	"./QQQUSD.svg": 430,
	"./SANDUSD.svg": 431,
	"./SBUXUSD.svg": 432,
	"./SHIBUSD.svg": 433,
	"./SNAPUSD.svg": 434,
	"./SNXUSD.svg": 435,
	"./SOLUSD.svg": 436,
	"./SPYUSD.svg": 437,
	"./THETAUSD.svg": 438,
	"./TRXUSD.svg": 439,
	"./TSLAUSD.svg": 440,
	"./UNIUSD.svg": 441,
	"./USDCAD.svg": 442,
	"./USDCHF.svg": 443,
	"./USDCNH.svg": 444,
	"./USDJPY.svg": 445,
	"./USDKRW.svg": 446,
	"./USDMXN.svg": 447,
	"./USDSGD.svg": 448,
	"./USDZAR.svg": 449,
	"./VUSD.svg": 450,
	"./WMTUSD.svg": 451,
	"./XAGUSD.svg": 452,
	"./XAUUSD.svg": 453,
	"./XLMUSD.svg": 454,
	"./XMRUSD.svg": 455,
	"./XRPUSD.svg": 456,
	"./XTZUSD.svg": 457,
	"./YFIUSD.svg": 458,
	"./ZECUSD.svg": 459,
	"./_LOGO SHARDEUM BLANCO.svg": 460,
	"./_LOGO ZKSYNC BLANCO.svg": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;